import { SagaIterator } from 'redux-saga';
import { fork } from 'redux-saga/effects';
import { rootFavoritesSaga } from '../../search/sagas/FavoritesSaga';
import { searchResultSaga } from '../../search/sagas/SearchResultSaga';

export function* rootSaga(): SagaIterator {
  yield fork(rootFavoritesSaga);
  yield fork(searchResultSaga);
}
